import { OnInit } from '@angular/core';
var AddCommunicationComponent = /** @class */ (function () {
    function AddCommunicationComponent() {
    }
    AddCommunicationComponent.prototype.ngOnInit = function () {
    };
    return AddCommunicationComponent;
}());
export { AddCommunicationComponent };
